module.exports = __webpack_public_path__ + "static/media/subtitle_education.4f92f862.svg";